import type { KaggleTier } from "./kaggleTiers";

export type LeagueRankingRow = {
  rank: number;
  combined_rank?: number;
  kaggle_id: string;
  grade: string;
  participant_type?:
    | "regular"
    | "university"
    | "graduate"
    | "professional"
    | "exhibition";
  kaggle_tier?: KaggleTier | null;
  season_points: number;
  competition_count: number;
  best_rank: number | null;
  updated_at: string | null;
};

export const mockLeagueRanking: LeagueRankingRow[] = [
  {
    rank: 1,
    combined_rank: 1,
    kaggle_id: "sample_challenger",
    grade: "高2",
    kaggle_tier: "grandmaster",
    season_points: 428.7312,
    competition_count: 14,
    best_rank: 2,
    updated_at: null,
  },
  {
    rank: 2,
    combined_rank: 3,
    kaggle_id: "data_youth_01",
    grade: "高1",
    kaggle_tier: "master",
    season_points: 316.4428,
    competition_count: 11,
    best_rank: 8,
    updated_at: null,
  },
  {
    rank: 3,
    combined_rank: 5,
    kaggle_id: "aiyss_member_demo",
    grade: "中3",
    kaggle_tier: "novice",
    season_points: 241.0954,
    competition_count: 9,
    best_rank: 17,
    updated_at: null,
  },
  {
    rank: 4,
    combined_rank: 6,
    kaggle_id: "young_ml_builder",
    grade: "高3",
    kaggle_tier: "contributor",
    season_points: 183.5071,
    competition_count: 7,
    best_rank: 31,
    updated_at: null,
  },
  {
    rank: 1,
    combined_rank: 2,
    kaggle_id: "university_ai_demo",
    grade: "大3",
    participant_type: "university",
    kaggle_tier: "expert",
    season_points: 392.6148,
    competition_count: 12,
    best_rank: 4,
    updated_at: null,
  },
  {
    rank: 2,
    combined_rank: 4,
    kaggle_id: "campus_ml_lab",
    grade: "院1",
    participant_type: "graduate",
    season_points: 267.9032,
    competition_count: 8,
    best_rank: 15,
    updated_at: null,
  },
  {
    rank: 3,
    combined_rank: 5,
    kaggle_id: "industry_ml_demo",
    grade: "社会人",
    participant_type: "professional",
    season_points: 214.3361,
    competition_count: 7,
    best_rank: 19,
    updated_at: null,
  },
  {
    rank: 5,
    combined_rank: 7,
    kaggle_id: "junior_one_demo",
    grade: "中1",
    season_points: 156.2831,
    competition_count: 6,
    best_rank: 42,
    updated_at: null,
  },
  {
    rank: 6,
    combined_rank: 8,
    kaggle_id: "junior_two_demo",
    grade: "中2",
    season_points: 129.7842,
    competition_count: 5,
    best_rank: 51,
    updated_at: null,
  },
];
